import { Grid } from '@react-three/drei';
import { Vector3 } from 'three';

interface GridBaseProps {
  fadeDistance?: number;
  cellSize?: number;
  sectionSize?: number;
  sectionColor?: string;
  cellColor?: string;
  fadeStrength?: number;
  infiniteGrid?: boolean;
  cellThickness?: number;
  sectionThickness?: number;
}

export function GridBase({
  fadeDistance = 80,
  cellSize = 2,
  sectionSize = 10,
  sectionColor = '#666666',
  cellColor = '#444444',
  fadeStrength = 0.8,
  infiniteGrid = true,
  cellThickness = 0.5,
  sectionThickness = 0.8,
}: GridBaseProps) {
  return (
    <>
      {/* Main Grid */}
      <Grid
        position={[0, -0.01, 0]}
        args={[100, 100]}
        cellSize={cellSize}
        cellThickness={cellThickness}
        cellColor={cellColor}
        sectionSize={sectionSize}
        sectionThickness={sectionThickness}
        sectionColor={sectionColor}
        fadeDistance={fadeDistance}
        fadeStrength={fadeStrength}
        infiniteGrid={infiniteGrid}
        followCamera={false}
      />
    </>
  );
}
